import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export const AccessDenied: React.FC = () => {
  const { logout } = useAuth();
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen flex items-center justify-center p-5 relative"
      style={{ background: 'var(--bg)' }}
    >
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <div
        className="max-w-md w-full p-12 text-center"
        style={{
          background: 'var(--surface)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow)',
          animation: 'panelIn 0.35s ease-out both',
        }}
      >
        <div className="inline-block mb-6">
          <svg className="w-16 h-16" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: 'var(--error)' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
        </div>

        <h1
          className="text-3xl font-semibold mb-4"
          style={{ fontFamily: 'var(--font-display)', color: 'var(--text)' }}
        >
          {t('auth.accessDenied.title')}
        </h1>

        <p className="mb-6 leading-relaxed" style={{ color: 'var(--text-muted)' }}>
          {t('auth.accessDenied.message')}
        </p>

        <div
          className="rounded-lg p-4 mb-6"
          style={{ background: '#fffbeb', border: '1px solid rgba(180,120,0,0.25)' }}
        >
          <p className="text-sm" style={{ color: '#92400e' }}>
            {t('auth.accessDenied.contactAdmin')}
          </p>
        </div>

        <button
          onClick={logout}
          className="w-full py-3 text-white rounded-md text-sm font-medium transition-colors cursor-pointer flex items-center justify-center gap-2"
          style={{ background: 'var(--error)' }}
          onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.background = '#a93226'}
          onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.background = 'var(--error)'}
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {t('auth.accessDenied.signOut')}
        </button>

        <p className="text-xs mt-6" style={{ color: 'var(--text-muted)', opacity: 0.5 }}>
          {t('auth.accessDenied.footer')}
        </p>
      </div>

      <style>{`
        @keyframes panelIn {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};
